import { render } from "./TheDashboard.vue?vue&type=template&id=22e6a114&scoped=true&ts=true"
import script from "./TheDashboard.vue?vue&type=script&lang=ts"
export * from "./TheDashboard.vue?vue&type=script&lang=ts"

import "./TheDashboard.vue?vue&type=style&index=0&id=22e6a114&lang=scss&scoped=true"
import "./TheDashboard.vue?vue&type=style&index=1&id=22e6a114&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e6a114"]])

export default __exports__